/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState, useEffect, useRef } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp, getConfig } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'
import FacebookLogin from '@greatsumini/react-facebook-login';
import { Schema } from 'inspector'
import { combineSelect2Values, normalizeLinkedinUsername, Select2Option } from '../../helpers/utility'
import DatePicker, { registerLocale } from "react-datepicker";
import "../../../styles/react-datepicker.css";
import { tr } from "date-fns/locale/tr";
import { addFacebookIntegration } from '../../../app/modules/auth/core/_requests'
import axios from 'axios'

type Props = {
  functionSubmit?: any
}
const animatedComponents = makeAnimated();

export class ChannelWizardDto {
  isTwitterOpen = true;
  isInstagramOpen = true;
  isFacebookAccountConnectionOpen = false;
  isFacebookOpen = true;
  isYoutubeOpen = true;
  isRedditOpen = false;
  isTikTokOpen = true;
  isLinkedinOpen = true;
  isNewsOpen = true;
  isSikayetvarOpen = false;
  isEksisozlukOpen = false;
  channelName = "";
  twitterUserName = "";
  facebookUserName = "";
  instagramUserName = "";
  linkedinUserName = "";
  tikTokUserName = "";
  subredditName = "";
  youtubeChannelId = "";
  newsQuery = "";
  hashtagList: object[] = [];
  searchQueryList: object[] = [];
  // accountExceptionList: object[] = [];
  searchUrl_Sikayetvar = "";
  searchUrl_Eksisozluk = "";
  companyId = "";
  dataRetrievalStartDate = new Date();
  isAutoSearch = true;
  language = "";
  isGetAccountSharings = true;
  isGetAccountSharingsComments = true;
  isCompetitor = false;
}

const ChannelWizardModal: FC<Props> = ({ functionSubmit }) => {

  const lang = getConfig()
  const { mode } = useThemeMode()

  const [isQuickFillLoading, setQuickFillLoading] = useState<boolean>(false)

  const [optionsHashtagList, updateOptionsHashtagList] = React.useState([] as Select2Option[]);
  const [optionsSearchQueryList, updateOptionsSearchQueryList] = React.useState([] as Select2Option[]);
  useEffect(() => {
    if (localStorage) {
      const localStorage_SearchQueryList: string | null = localStorage.getItem("optionsSearchQueryList_Key")
      if (localStorage_SearchQueryList) {
        try {
          const options: [Select2Option] = JSON.parse(localStorage_SearchQueryList) as [Select2Option]
          if (options) {

            updateOptionsSearchQueryList(options);
          }
        } catch (error) {
          console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
        }
      }
      const localStorage_HashtagList: string | null = localStorage.getItem("optionsHashtagList_Key")
      if (localStorage_HashtagList) {
        try {
          const options: [Select2Option] = JSON.parse(localStorage_HashtagList) as [Select2Option]
          if (options) {

            updateOptionsHashtagList(options);
          }
        } catch (error) {
          console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
        }
      }
    }

    formik.setFieldValue('dataRetrievalStartDate', null)
    if (lang.selectedLang == "tr") {
      registerLocale("tr-TR", tr);
    }
  }, []);

  const getQuickFillWithAI = async () => {

    if (!formik.touched.channelName || formik.errors.channelName) {
      toast.error("LanguageHelp(response.data.message)");
      return false;
    } else {
      setQuickFillLoading(true);
      const toastId = toast.loading(LanguageHelp('Your process has been started!'));

      var payload = {
        channelName: formik.getFieldProps('channelName').value,
      }

      return axios
        .post(`${process.env.REACT_APP_API_URL}/settings/GetChannelQuickFillWithAI`, payload)
        .then((response) => {
          if (response.data.httpStatusCode === 200) {

            if (response.data.message !== null) {
              toast.update(toastId, { render: LanguageHelp(response.data.message), type: "warning", isLoading: false, autoClose: 3000 });
            } else {
              var quickFillSocialMedias = response.data.result.data

              var hashtagList = quickFillSocialMedias[0].socialMedias.instagram.hashtags.map((item: any) => {
                const hashtag = typeof item === 'string' && !item.startsWith('#') ? `#${item}` : item;
                return new Select2Option(hashtag, hashtag);
              })
              var searchQueryList = quickFillSocialMedias[0].socialMedias.twitter.searchKeywords.map((item: any) => new Select2Option(item, item));

              if (quickFillSocialMedias.length > 0) {
                formik.setFieldValue('hashtagList', hashtagList);
                formik.setFieldValue('searchQueryList', searchQueryList);
                formik.setFieldValue('facebookUserName', quickFillSocialMedias[0].socialMedias.facebook.username || '');
                formik.setFieldValue('instagramUserName', quickFillSocialMedias[0].socialMedias.instagram.username || '');
                formik.setFieldValue('youtubeChannelId', quickFillSocialMedias[0].socialMedias.youtube.channelId || '');
                formik.setFieldValue('twitterUserName', quickFillSocialMedias[0].socialMedias.twitter.username || '');
                formik.setFieldValue('linkedinUserName', normalizeLinkedinUsername(quickFillSocialMedias[0].socialMedias.linkedin.username || ''));
                formik.setFieldValue('tikTokUserName', quickFillSocialMedias[0].socialMedias.tikTok.username || '');
                formik.setFieldValue('subredditName', quickFillSocialMedias[0].socialMedias.reddit.subredditName || '');
                formik.setFieldValue('newsQuery', quickFillSocialMedias[0].socialMedias.googleForNews.searchKeywords[0] || '');
                formik.setFieldValue('searchUrl_Sikayetvar', quickFillSocialMedias[0].socialMedias.sikayetvar.url || '');
                formik.setFieldValue('searchUrl_Eksisozluk', quickFillSocialMedias[0].socialMedias.eksisözluk.url || '');

                formik.setFieldTouched('hashtagList', true, false);
                formik.setFieldTouched('searchQueryList', true, false);
                formik.setFieldTouched('facebookUserName', true, false);
                formik.setFieldTouched('instagramUserName', true, false);
                formik.setFieldTouched('youtubeChannelId', true, false);
                formik.setFieldTouched('twitterUserName', true, false);
                formik.setFieldTouched('linkedinUserName', true, false);
                formik.setFieldTouched('tikTokUserName', true, false);
                formik.setFieldTouched('subredditName', true, false);
                formik.setFieldTouched('newsQuery', true, false);
                formik.setFieldTouched('searchUrl_Sikayetvar', true, false);
                formik.setFieldTouched('searchUrl_Eksisozluk', true, false);

                setTimeout(function () {
                  formik.validateForm();
                }, 2000);

                toast.update(toastId, { render: LanguageHelp('Subject suggestions received successfully!'), type: "success", isLoading: false, autoClose: 3000 });
              } else {
                toast.update(toastId, { render: "Unexpected error", type: "error", isLoading: false, autoClose: 3000 });
              }
            }
          } else {
            toast.update(toastId, { render: response.data.message, type: "error", isLoading: false, autoClose: 3000 });
          }
          setQuickFillLoading(false);
          return response.data.result;
        })
        .then((response: any) => response)
    }
  }

  const createChannelSchema = Yup.object().shape({
    channelName: Yup.string()
      .min(3, LanguageHelp('Minimum 3 symbols'))
      .max(50, LanguageHelp('Maximum 50 symbols'))
      .required(LanguageHelp('Channel name is required')),
    twitterUserName: Yup.string().when('isTwitterOpen',
      (isTwitterOpen, schema) => {
        if (isTwitterOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-zA-Z0-9_]*$", LanguageHelp("Your username can only contain letters, numbers and \"_\""))
            .required(LanguageHelp('Twitter username is required'))
        }
        else { return schema; }
      }),
    facebookUserName: Yup.string().when('isFacebookOpen',
      (isFacebookOpen, schema) => {
        if (isFacebookOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-zA-Z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('Facebook username is required'))
        }
        else { return schema; }
      }),
    instagramUserName: Yup.string().when('isInstagramOpen',
      (isInstagramOpen, schema) => {
        if (isInstagramOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-zA-Z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('Instagram username is required'))
        }
        else { return schema; }
      }),
    youtubeChannelId: Yup.string().when('isYoutubeOpen',
      (isYoutubeOpen, schema) => {
        if (isYoutubeOpen) {
          return schema.test({
            name: 'valid-or-ignored',
            message: LanguageHelp('Must be exactly 24 digits'),
            test: function (value: string | any[]) {
              if (!value) return true;
              const lower = value.toString().toLowerCase();
              if (['bulunamadi', 'bulunamadı', 'none', 'no', 'not exist', 'notexist', 'yok', 'na', 'n/a', 'N/A'].includes(lower)) return true;
              return value.length === 24;
            },
          });
        }
        else { return schema; }
      }),
    // subredditName: Yup.string().when('isRedditOpen', {
    //   is: true, // isRedditOpen === true olduğunda
    //   then: schema =>
    //     schema
    //       .min(3, LanguageHelp('Minimum 3 symbols'))
    //       .max(21, LanguageHelp('Maximum 21 symbols'))
    //       .matches(/^[a-zA-Z0-9_]*$/, LanguageHelp('Subreddit name is wrong'))
    //       .required(LanguageHelp('Subreddit name is required')),
    //   otherwise: schema => schema.notRequired(), // false ise zorunlu değil
    // }),
    tikTokUserName: Yup.string().when('isTikTokOpen',
      (isTikTokOpen, schema) => {
        if (isTikTokOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches("^[a-z0-9_.]*$", LanguageHelp("Your username can only contain lowercase letters, numbers, \".\" and \"_\""))
            .required(LanguageHelp('TikTok username is required'))
        }
        else { return schema; }
      }),
    linkedinUserName: Yup.string().when('isLinkedinOpen',
      (isLinkedinOpen, schema) => {
        if (isLinkedinOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .matches(/^[A-Za-z0-9-]*$/, LanguageHelp("Your username can only contain lowercase letters, uppercase letters, numbers and \"-\""))
            .required(LanguageHelp('Linkedin username is required'))
        }
        else { return schema; }
      }),
    newsQuery: Yup.string().when('isNewsOpen',
      (isNewsOpen, schema) => {
        if (isNewsOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .required(LanguageHelp('Search query is required'))
        }
        else { return schema; }
      }),
    searchQueryList: Yup.array().when('type',
      (type, schema) => {
        return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
          label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols'))
          // Rest of your amenities object properties
        }))
      }),
    hashtagList: Yup.array().when('type',
      (type, schema) => {
        return schema.min(1, "minimum 1 pick").of(Yup.object().shape({
          label: Yup.string().min(3, LanguageHelp('Minimum 3 symbols')).matches(/^#/, LanguageHelp("starts with #"))
          // Rest of your amenities object properties
        }))
      }),
    searchUrl_Sikayetvar: Yup.string().when('isSikayetvarOpen',
      (isSikayetvarOpen, schema) => {
        if (isSikayetvarOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .url(LanguageHelp('The text you enter must be the url'))
            .required(LanguageHelp('Search url is required'))
        } else {
          return schema;
        }
      }),
    searchUrl_Eksisozluk: Yup.string().when('isEksisozlukOpen',
      (isEksisozlukOpen, schema) => {
        if (isEksisozlukOpen) {
          return schema.min(3, LanguageHelp('Minimum 3 symbols'))
            .url(LanguageHelp('The text you enter must be the url'))
            .required(LanguageHelp('Search url is required'))
        } else {
          return schema;
        }
      }),
  })
  const [channelWizardDto, setChannelWizardDto] = useState(new ChannelWizardDto())

  const formik = useFormik({
    initialValues: channelWizardDto,
    validationSchema: createChannelSchema,
    onSubmit: async (values, { setSubmitting }) => {
      // if ((values.isGetAccountSharings || values.isGetAccountSharingsComments) && (values.searchQuery == null || values.searchQuery == undefined || values.searchQuery == "")) {
      //   toast.error(LanguageHelp('Without entering a username, posts or comments related to the account cannot be retrieved!'));
      // } else {
      isSuccess = false
      try {
        var queryList: string[] = []
        var hashtagList: string[] = [] // TODO: add hashtagList to request
        values.searchQueryList.forEach(searchQuery => {
          queryList.push(Object(searchQuery)['label'])
        });
        values.hashtagList.forEach(hashtag => {
          hashtagList.push(Object(hashtag)['label'])
        });
        // var accountExceptionList: string[] = []
        // values.accountExceptionList.forEach(accountException => {
        //   accountExceptionList.push(Object(accountException)['label'])
        // });
        var isSuccess = await functionSubmit(
          values.isTwitterOpen,
          values.isFacebookOpen,
          values.isInstagramOpen,
          values.isYoutubeOpen,
          values.isRedditOpen,
          values.isTikTokOpen,
          values.isLinkedinOpen,
          values.isNewsOpen,
          values.isSikayetvarOpen,
          values.isEksisozlukOpen,
          values.channelName,
          "", // values.companyId,
          values.newsQuery,
          queryList,
          hashtagList,
          values.twitterUserName,
          values.facebookUserName,
          values.instagramUserName,
          values.linkedinUserName,
          values.tikTokUserName,
          values.subredditName,
          values.youtubeChannelId,
          // accountExceptionList, // accountExceptionList
          values.searchUrl_Sikayetvar,
          values.searchUrl_Eksisozluk,
          values.dataRetrievalStartDate,
          values.language,
          values.isAutoSearch,
          values.isCompetitor,
          values.isGetAccountSharings,
          values.isGetAccountSharingsComments,
        )
        console.log(isSuccess, "isSuccess")
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
        }
      }
      // }
    },
  })

  React.useEffect(() => {
    formik.validateForm();
  }, [formik.values]);

  return (
    <div className='modal fade' id='kt_modal_channel_wizard' aria-hidden='true'>
      <div className='modal-dialog modal-lg'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Add Channel')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >

                {/* begin::Input group */}
                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Channel Name')}</label>
                    <div className='col-lg-5 fv-row'>
                      <input
                        placeholder={LanguageHelp('Company or Person Name')}
                        {...formik.getFieldProps('channelName')}
                        type='text'
                        name='channelName'
                        className={clsx('form-control form-control-lg form-control-solid')}
                        autoComplete='off'
                        disabled={formik.isSubmitting}
                      />
                      {formik.touched.channelName && formik.errors.channelName && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.channelName}</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='col-lg-3 fv-row'>
                      <button
                        type='button'
                        onClick={() => getQuickFillWithAI()}
                        className='btn btn-info me-3 mb-2'
                        data-kt-review-modal-action='addtranslation'
                        disabled={formik.isSubmitting || isQuickFillLoading || (formik.touched.channelName && !!formik.errors.channelName)}
                      >
                        <i className="fas fa-wand-magic-sparkles"></i>
                        {LanguageHelp('Quick Fill')}
                      </button>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isTwitterOpen')}
                        checked={formik.values.isTwitterOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isTwitterOpen'>
                        {LanguageHelp('Twitter')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isFacebookOpen')}
                        checked={formik.values.isFacebookOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isFacebookOpen'>
                        {LanguageHelp('Facebook')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isInstagramOpen')}
                        checked={formik.values.isInstagramOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isInstagramOpen'>
                        {LanguageHelp('Instagram')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isYoutubeOpen')}
                        checked={formik.values.isYoutubeOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isYoutubeOpen'>
                        {LanguageHelp('Youtube')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isTikTokOpen')}
                        checked={formik.values.isTikTokOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isTikTokOpen'>
                        {LanguageHelp('TikTok')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isLinkedinOpen')}
                        checked={formik.values.isLinkedinOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isLinkedinOpen'>
                        {LanguageHelp('Linkedin')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isNewsOpen')}
                        checked={formik.values.isNewsOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isNewsOpen'>
                        {LanguageHelp('News')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isRedditOpen')}
                        checked={formik.values.isRedditOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isRedditOpen'>
                        {LanguageHelp('Reddit')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isSikayetvarOpen')}
                        checked={formik.values.isSikayetvarOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isSikayetvarOpen'>
                        {LanguageHelp('Şikayetvar')}
                      </label>
                    </div>
                  </div>
                  <div className='col-lg-3 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isEksisozlukOpen')}
                        checked={formik.values.isEksisozlukOpen}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isEksisozlukOpen'>
                        {LanguageHelp('Ekşisözluk')}
                      </label>
                    </div>
                  </div>
                </div>


                {/* end::Input group */}
                {(formik.values.isTwitterOpen || formik.values.isYoutubeOpen || formik.values.isLinkedinOpen || formik.values.isRedditOpen || formik.values.isTikTokOpen) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Texts to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsSearchQueryList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several text(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('searchQueryList')}
                            onChange={(searchQueryList) => formik.setFieldValue('searchQueryList', searchQueryList)}
                            onCreateOption={(inputValue) => {
                              const values = inputValue.split(',').map(v => v.trim()).filter(v => v);
                              const current = formik.values.searchQueryList || [];
                              const newValues = [
                                ...current,
                                ...values.map(v => ({ label: v, value: v }))
                              ];
                              formik.setFieldValue('searchQueryList', newValues);
                            }}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.touched.searchQueryList && formik.errors.searchQueryList && formik.errors.searchQueryList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The texts to be searched must be at least one, and the number of letters of the texts must be at least 3.")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.isFacebookOpen || formik.values.isInstagramOpen) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Hashtag to Search')}</label>
                        <div className='col-lg-8 fv-row'>
                          <CreatableSelect
                            defaultValue={[]}
                            isMulti
                            className={mode === 'light' ? 'basic-multi-select' : 'basic-multi-select dark'}
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            options={optionsHashtagList}
                            components={animatedComponents}
                            noOptionsMessage={() => LanguageHelp('You can add a new value!')}
                            placeholder={LanguageHelp('Write one/several hashtag(s)...')}
                            formatCreateLabel={(inputValue) => `${LanguageHelp('Create new...')} ${inputValue}`}
                            {...formik.getFieldProps('hashtagList')}
                            onChange={(hashtagList) => formik.setFieldValue('hashtagList', hashtagList)}
                            onCreateOption={(inputValue) => {
                              const values = inputValue.split(',').map(v => v.trim()).filter(v => v);
                              const current = formik.values.hashtagList || [];
                              const newValues = [
                                ...current,
                                ...values.map(v => ({ label: v, value: v }))
                              ];
                              formik.setFieldValue('hashtagList', newValues);
                            }}
                            styles={{
                              control: (base) => ({ ...base, fontWeight: '600' })
                              , multiValueRemove: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                              , menu: (base) => ({ ...base, paddingLeft: '0px', paddingRight: '1px' })
                            }}
                          />
                          {formik.touched.hashtagList && formik.errors.hashtagList && formik.errors.hashtagList !== undefined && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{LanguageHelp("The hashtags to be searched must be at least one, and the number of letters of the hashtags must be at least 3. Hashtags must be start with '#' character")}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.isNewsOpen)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('News Search Query')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('News Search Query')}
                          {...formik.getFieldProps('newsQuery')}
                        />
                        {formik.touched.newsQuery && formik.errors.newsQuery && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.newsQuery}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }

                {/* -------------------- */}
                {(formik.values.isFacebookAccountConnectionOpen) &&
                  <div>
                    <FacebookLogin
                      appId="1701216940365266"
                      scope="pages_show_list,instagram_basic,instagram_manage_comments,instagram_manage_messages,pages_messaging"
                      render={renderProps => (
                        <button type="button" onClick={renderProps.onClick} style={{ border: "none", backgroundColor: '#0866ff', color: 'white', padding: '10px', width: "50%", alignContent: "center", display: "block", marginRight: "auto", marginLeft: "auto" }}>
                          Facebook
                        </button>
                      )}
                      onSuccess={(res) => {
                        const accessToken = res.accessToken;
                        // const userID = res.userID;
                        var addFacebookIntegrationResult = addFacebookIntegration(accessToken)
                      }}
                      onFail={(err) => console.error('Fail', err)}
                      onProfileSuccess={(res) => console.log('Profile', res)}
                    />
                  </div>
                }
                {/* -------------------- */}

                {(formik.values.isTwitterOpen) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Twitter Username')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Twitter Username')}
                            {...formik.getFieldProps('twitterUserName')}
                          />
                        </div>
                        <div className='form-text'>
                          {LanguageHelp("If no account exists, please enter \"notfound\".")}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.isFacebookOpen) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Facebook Username')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Facebook Username')}
                            {...formik.getFieldProps('facebookUserName')}
                          />
                          {formik.touched.facebookUserName && formik.errors.facebookUserName && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.facebookUserName}</div>
                            </div>
                          )}
                        </div>
                        <div className='form-text'>
                          {LanguageHelp("If no account exists, please enter \"notfound\".")}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.isInstagramOpen) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Instagram Username')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Instagram Username')}
                            {...formik.getFieldProps('instagramUserName')}
                          />
                          {formik.touched.instagramUserName && formik.errors.instagramUserName && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.instagramUserName}</div>
                            </div>
                          )}
                        </div>
                        <div className='form-text'>
                          {LanguageHelp("If no account exists, please enter \"notfound\".")}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.isLinkedinOpen)) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Linkedin Username')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Linkedin Username')}
                            {...formik.getFieldProps('linkedinUserName')}
                          />
                          {formik.touched.linkedinUserName && formik.errors.linkedinUserName && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.linkedinUserName}</div>
                            </div>
                          )}
                        </div>
                        <div className='form-text'>
                          {LanguageHelp("If no account exists, please enter \"notfound\".")}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.isTikTokOpen) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('TikTok Username')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('TikTok Username')}
                            {...formik.getFieldProps('tikTokUserName')}
                          />
                          {formik.touched.tikTokUserName && formik.errors.tikTokUserName && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.tikTokUserName}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {((formik.values.isYoutubeOpen)) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Youtube Channel Id')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          placeholder={LanguageHelp('Youtube Channel Id')}
                          {...formik.getFieldProps('youtubeChannelId')}
                        />
                        {formik.touched.youtubeChannelId && formik.errors.youtubeChannelId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.youtubeChannelId}</div>
                          </div>
                        )}
                      </div>
                      <div className='form-text'>
                        {LanguageHelp("If no account exists, please enter \"notfound\".")}
                      </div>
                    </div>
                  </div>
                }

                {/* {((formik.values.isRedditOpen)) &&
                  <div>
                    <div className='fv-row mb-7'>
                      <div className='row mb-6'>
                        <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Subreddit Name')}</label>
                        <div className='col-lg-8 fv-row'>
                          <input
                            type='text'
                            className='form-control form-control-lg form-control-solid'
                            placeholder={LanguageHelp('Subreddit Name')}
                            {...formik.getFieldProps('subredditName')}
                          />
                          {formik.touched.subredditName && formik.errors.subredditName && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>{formik.errors.subredditName}</div>
                            </div>
                          )}
                        </div>
                        <div className='form-text'>
                          {LanguageHelp("If no account exists, please enter \"notfound\".")}
                        </div>
                      </div>
                    </div>
                  </div>
                } */}
                {(formik.values.isSikayetvarOpen) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Şikayetvar Url')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          // placeholder={(formik.values.type == 13 ? 'https://www.linkedin.com/search/results/content/?keywords=aisenseus&origin=GLOBAL_SEARCH_HEADER&sid=AhU&sortBy=%22date_posted%22': (formik.values.type == 14 ? 'https://www.linkedin.com/company/aisenseus': LanguageHelp('Url to search')))}
                          placeholder={LanguageHelp('Şikayetvar Url')}
                          {...formik.getFieldProps('searchUrl_Sikayetvar')}
                        />
                        {formik.touched.searchUrl_Sikayetvar && formik.errors.searchUrl_Sikayetvar && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchUrl_Sikayetvar}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {(formik.values.isEksisozlukOpen) &&
                  <div className='fv-row mb-7'>
                    <div className='row mb-6'>
                      <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Ekşisözluk Url')}</label>
                      <div className='col-lg-8 fv-row'>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          // placeholder={(formik.values.type == 13 ? 'https://www.linkedin.com/search/results/content/?keywords=aisenseus&origin=GLOBAL_SEARCH_HEADER&sid=AhU&sortBy=%22date_posted%22': (formik.values.type == 14 ? 'https://www.linkedin.com/company/aisenseus': LanguageHelp('Url to search')))}
                          placeholder={LanguageHelp('Ekşisözluk Url')}
                          {...formik.getFieldProps('searchUrl_Eksisozluk')}
                        />
                        {formik.touched.searchUrl_Eksisozluk && formik.errors.searchUrl_Eksisozluk && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{formik.errors.searchUrl_Eksisozluk}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                }

                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Data Retrieval Start Date')}</label>
                  <div className='col-lg-8 fv-row'>
                    <div
                      className='btn btn-icon btn-active-color-primary w-40px h-40px me-3' style={{ backgroundColor: mode === 'light' ? "#f5f8fa" : "#1b1b29", marginBottom: "4px" }}
                      onClick={(date) => formik.setFieldValue('dataRetrievalStartDate', null)}
                    >
                      <KTSVG path='/media/icons/duotune/abstract/abs012.svg' className=' svg-icon-1' style={{ filter: mode === 'light' ? "brightness(100%)" : "brightness(200%)", marginBottom: "4px" }} />
                    </div>
                    <DatePicker
                      // showIcon
                      locale={lang.selectedLang == "tr" ? "tr-TR" : "en-US"}
                      className='form-select form-select-solid form-select-lg'
                      dateFormat={lang.selectedLang == "tr" ? "dd.MM.yyyy" : "MM.dd.yyyy"}
                      selected={formik.values.dataRetrievalStartDate}
                      // preventOpenOnFocus={true}
                      // maxDate={new Date()}
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={50}
                      // isClearable 
                      placeholderText={LanguageHelp('Select a date...')}
                      onChange={(date) => formik.setFieldValue('dataRetrievalStartDate', date)}
                    />
                  </div>
                </div>

                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Language Restriction')}</label>
                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-solid form-select-lg'
                      {...formik.getFieldProps('language')}
                    >
                      <option value=''>{LanguageHelp('Select a Language...')}</option>
                      <option value='en'>English</option>
                      <option value='tr'>Türkçe - Turkish</option>
                      <option value='id'>Bahasa Indonesia - Indonesian</option>
                      <option value='msa'>Bahasa Melayu - Malay</option>
                      <option value='ca'>Català - Catalan</option>
                      <option value='cs'>Čeština - Czech</option>
                      <option value='da'>Dansk - Danish</option>
                      <option value='de'>Deutsch - German</option>
                      <option value='en'>English</option>
                      <option value='en-gb'>English UK - British English</option>
                      <option value='es'>Español - Spanish</option>
                      <option value='fil'>Filipino</option>
                      <option value='fr'>Français - French</option>
                      <option value='ga'>Gaeilge - Irish (beta)</option>
                      <option value='gl'>Galego - Galician (beta)</option>
                      <option value='hr'>Hrvatski - Croatian</option>
                      <option value='it'>Italiano - Italian</option>
                      <option value='hu'>Magyar - Hungarian</option>
                      <option value='nl'>Nederlands - Dutch</option>
                      <option value='no'>Norsk - Norwegian</option>
                      <option value='pl'>Polski - Polish</option>
                      <option value='pt'>Português - Portuguese</option>
                      <option value='ro'>Română - Romanian</option>
                      <option value='sk'>Slovenčina - Slovak</option>
                      <option value='fi'>Suomi - Finnish</option>
                      <option value='sv'>Svenska - Swedish</option>
                      <option value='vi'>Tiếng Việt - Vietnamese</option>
                      <option value='tr'>Türkçe - Turkish</option>
                      <option value='el'>Ελληνικά - Greek</option>
                      <option value='bg'>Български език - Bulgarian</option>
                      <option value='ru'>Русский - Russian</option>
                      <option value='sr'>Српски - Serbian</option>
                      <option value='uk'>Українська мова - Ukrainian</option>
                      <option value='he'>עִבְרִית - Hebrew</option>
                      <option value='ur'>اردو - Urdu (beta)</option>
                      <option value='ar'>العربية - Arabic</option>
                      <option value='fa'>فارسی - Persian</option>
                      <option value='mr'>मराठी - Marathi</option>
                      <option value='hi'>हिन्दी - Hindi</option>
                      <option value='bn'>বাংলা - Bangla</option>
                      <option value='gu'>ગુજરાતી - Gujarati</option>
                      <option value='ta'>தமிழ் - Tamil</option>
                      <option value='kn'>ಕನ್ನಡ - Kannada</option>
                      <option value='th'>ภาษาไทย - Thai</option>
                      <option value='ko'>한국어 - Korean</option>
                      <option value='ja'>日本語 - Japanese</option>
                      <option value='zh-cn'>简体中文 - Simplified Chinese</option>
                      <option value='zh-tw'>繁體中文 - Traditional Chinese</option>
                    </select>

                  </div>
                  <div className='form-text'>
                    {LanguageHelp('Allows you to see data in the selected language only. If you do not want to impose restrictions, you can leave it blank.')}
                  </div>
                  <div className='form-text'>
                    {LanguageHelp('You will continue to pull content outside of this language and you will be charged for this content, but you will not see it. There will be no extra data collection and fees for platforms that offer language search.')}
                  </div>
                </div>

                <div>
                  <div className='col-lg-6 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isGetAccountSharings')}
                        checked={formik.values.isGetAccountSharings}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isGetAccountSharings'>
                        {LanguageHelp('Take the shares too.')}
                      </label>
                    </div>
                    {formik.touched.isGetAccountSharings && formik.errors.isGetAccountSharings && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.isGetAccountSharings}</div>
                      </div>
                    )}

                  </div>
                </div>
                <div>
                  <div className='col-lg-6 fv-row mb-7'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isGetAccountSharingsComments')}
                        checked={formik.values.isGetAccountSharingsComments}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isGetAccountSharingsComments'>
                        {LanguageHelp('Take the comments too.')}
                      </label>
                    </div>
                    {formik.touched.isGetAccountSharingsComments && formik.errors.isGetAccountSharingsComments && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.isGetAccountSharingsComments}</div>
                      </div>
                    )}

                  </div>
                </div>

                <div>
                  <div className='col-lg-8 fv-row'>
                    <div className='form-check form-check-solid fv-row'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps('isAutoSearch')}
                        checked={formik.values.isAutoSearch}
                        onChange={formik.handleChange}
                      />
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isAutoSearch'>
                        {LanguageHelp('I want daily data collection.')}
                      </label>
                    </div>
                    {formik.touched.isAutoSearch && formik.errors.isAutoSearch && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>{formik.errors.isAutoSearch}</div>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className='col-lg-8 fv-row'>
                      <br></br>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isCompetitor')}
                          checked={formik.values.isCompetitor}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isCompetitor'>
                          {LanguageHelp('This is a competitor channel.')}
                        </label>
                      </div>
                      {formik.touched.isCompetitor && formik.errors.isCompetitor && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isCompetitor}</div>
                        </div>
                      )}
                    </div>

                    {/* {(formik.values.isCompetitor == true) &&
                      <div className='fv-row mb-7 mt-7'>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-bold fs-6'>{LanguageHelp('Competitor Name')}</label>
                          <div className='col-lg-8 fv-row'>
                            <input
                              placeholder={LanguageHelp('Competitor Name')}
                              {...formik.getFieldProps('competitorName')}
                              type='text'
                              name='competitorName'
                              className={clsx('form-control form-control-lg form-control-solid')}
                              autoComplete='off'
                              disabled={formik.isSubmitting}
                            />
                            {formik.touched.competitorName && formik.errors.competitorName && (
                              <div className='fv-plugins-message-container'>
                                <div className='fv-help-block'>
                                  <span role='alert'>{formik.errors.competitorName}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                    } */}
                  </div>
                </div>

              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='button'
                  // onClick={() => addTranslation()}
                  className='btn btn-info me-3 mb-2'
                  data-kt-review-modal-action='addtranslation'
                // disabled={formik.isSubmitting || isReviewLoading}
                >
                  <i className="fas fa-wand-magic-sparkles"></i>
                  {LanguageHelp('Quick Fill')}
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  data-kt-users-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  <i className="fas fa-paper-plane"></i>
                  <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                  {(formik.isSubmitting) && (
                    <span className='indicator-progress'>
                      {LanguageHelp('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { ChannelWizardModal }
